import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export default function ProductDetails(props) {
  const { id } = props;
  let location = useLocation();

  let products = useSelector((state) => state.product.products);

  const [product, setProduct] = useState(
    location.state && location.state.product ? location.state.product : null,
  );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!product) {
      setLoading(true);
      products.forEach((product) => {
        if (product.id == id) {
          setProduct(product);
        }
      });
    }
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [product]);

  if (loading) {
    return <Skeleton count={50} />;
  }

  if (!product) {
    return <div>Nothing to show</div>;
  }

  return (
    <div className="table-responsive">
    <table className="table table-striped table-bordered shadow-sm p-3 mb-0">
      <tbody>
        <tr>
          <th>Image</th>
          <td>
            <img src={`${product.image}`} alt={product.title || "Product"} width={200} />
          </td>
        </tr>

        {product.video && <tr>
          <th>Video</th>
          <td>
            <video src={product.video} controls preload="metadata" style={{ width: "100%", maxWidth: "720px" }}>
              Your browser does not support video playback.
            </video>
          </td>
        </tr>}

        <tr>
          <th>Title</th>
          <td>{product.title}</td>
        </tr>
        <tr>
          <th>Product type</th>
          <td>{product.ptype}</td>
        </tr>
        <tr>
          <th>Description</th>
          <td>{product.description}</td>
        </tr>

        <tr>
          <th>Tags</th>
          <td>{product.tags.join(", ")}</td>
        </tr>
        <tr>
          <th>Price</th>
          <td>
            {product.price} {product.currency}
          </td>
        </tr>
        <tr>
          <th>Payment period</th>
          <td>{product.validity_unit}</td>
        </tr>
      </tbody>
    </table>
    </div>
  );
}
